import React, { useState } from "react";
import IotModelViewerBtn from "../../../ui/iot-model-viewer-btn/IotModelViewerBtn";
import { ViewingOptionsProps } from "./viewing-options-props.interface";

import { ViewingOptionsItemProps } from "./viewing-options-props.interface";
import "./_viewing-options.scss";

const ViewingOptionsItem = ({
  itemKey,
  activeItemKey,
  onClick: handleClick,
  icon,
  activeItemIcon,
  content,
  className,
}: ViewingOptionsItemProps) => {
  const itemClassName = itemKey === activeItemKey ? " item--active" : "";

  const itemIcon = itemKey === activeItemKey && activeItemIcon ? activeItemIcon : icon;

  return (
    <li className="viewing-options-item__li-wrapper">
      <IotModelViewerBtn
        className={`${className || ""}${itemClassName}`}
        type="button"
        onClick={handleClick}
        icon={itemIcon}
        content={content}
      />
    </li>
  );
};

const ViewingOptions = ({ viewingOptionItems }: ViewingOptionsProps) => {
  const [activeItemKey, setActiveItemKey] = useState(null);
  const wrapItemInteraction =
    (itemKey: string, callback: Function) => (e: Event) => {
      if (itemKey !== activeItemKey) {
        // @ts-ignore
        setActiveItemKey(itemKey);
      };
      return callback();
    };

  return (
    <ul className="viewing-options d-inline-flex align-items-end justify-content-around p-4 list-unstyled">
      {viewingOptionItems?.map(
        ({ itemKey, messageAction, icon, activeItemIcon, content }) => (
          <ViewingOptionsItem
            key={itemKey}
            itemKey={itemKey}
            activeItemKey={activeItemKey}
            icon={icon}
            activeItemIcon={activeItemIcon}
            content={content}
            onClick={wrapItemInteraction(itemKey, messageAction)}
          />
        )
      )}
    </ul>
  );
};

export default ViewingOptions;
